export class EventStream {
    constructor(client) {
        Object.defineProperty(this, "buffer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "unsub", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.unsub = client.onEvents((events) => {
            for (const e of events)
                this.buffer.push(e);
            if (this.buffer.length > 1024) {
                console.warn(`[EventStream] buffer overflow (${this.buffer.length}); ` +
                    `dropping oldest — render loop may be stalled`);
                this.buffer.splice(0, this.buffer.length - 1024);
            }
        });
    }
    drain() {
        if (this.buffer.length === 0)
            return [];
        const out = this.buffer;
        this.buffer = [];
        return out;
    }
    latest() {
        return this.buffer.length ? this.buffer[this.buffer.length - 1] : null;
    }
    dispose() {
        this.unsub();
        this.buffer = [];
    }
}
